import Navbar from "../components/site/Navbar";
import Hero from "../components/site/Hero";
import About from "../components/site/About";
import CoveragePlans from "../components/site/CoveragePlans";
import Benefits from "../components/site/Benefits";
import HowItWorks from "../components/site/HowItWorks";
import FAQ from "../components/site/FAQ";
import Testimonials from "../components/site/Testimonials";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";
import ChatWidget from "../components/site/ChatWidget";

export default function Landing() {
  return (
    <div className="bg-ivory min-h-screen" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <About />
        <CoveragePlans />
        <Benefits />
        <HowItWorks />
        <Testimonials />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
}
